import { adalFetch, AuthenticationContext, withAdalLogin } from 'react-adal'

import Config from './config'

export const authContext = new AuthenticationContext(Config.adalConfig)

export const adalApiFetch = (fetch, url, options) => adalFetch(authContext, Config.adalConfig.endpoints.api, fetch, url, options)

export const withAdalLoginApi = withAdalLogin(authContext, Config.adalConfig.endpoints.api)

export const getToken = () => authContext.getCachedToken(authContext.config.clientId)

export const getUser = () => authContext.getCachedUser()
